import { SelfServeContext } from "../../types";

import { isAusRetailer, isCanRetailer, isEurRetailer } from "./shared-utils";

export const VatAndTaxIdentifiersVisibilityFn = (_context: SelfServeContext) =>
  Promise.resolve(isEurRetailer() || isAusRetailer() || isCanRetailer());
